import styled from "styled-components";

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: right;
  filter: brightness(0.6);
`;
